const STICKY_CLASS = 'Header--sticky';
const headerOffset = 50;
const header = document.querySelector('.Header');

const toggleSticky = () => {
    window.scrollY > headerOffset
        ? header.classList.add(STICKY_CLASS)
        : header.classList.remove(STICKY_CLASS);
};

window.addEventListener('scroll', toggleSticky);



import Swiper, {Autoplay, Pagination } from 'swiper';

if (document.querySelector('.catgallery-slider')) {
    const swiper = new Swiper('.catgallery-slider .swiper', {
        modules: [Autoplay, Pagination],
        loop: true,
        speed: 700,
        spaceBetween: 0,
        slidesPerView: 1,

        autoplay: {
            delay: 3500,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
        },
        pagination: {
            el: '.swiper-pagination',
            type: 'custom',
            renderCustom: function (swiper, current, total) {
                const formatNumber = (num) => (num < 10 ? '0' + num : num);
                return `<span class="active">${formatNumber(current)}</span> <span class="separator"></span><span class="total">${formatNumber(total)}</span></span>`;
            },
        },

    });
}


document.addEventListener('DOMContentLoaded', function () {
    const openBtn = document.getElementById('OpenFormPopup');
    const closeBtn = document.getElementById('closeFormPopup');
    const formPopup = document.querySelector('.FormPopup');
    const body = document.body;

    if (openBtn && formPopup) {
        openBtn.addEventListener('click', function () {
            formPopup.classList.add('active');
            body.classList.add('no-scroll');
            body.classList.add('addblur');
        });
    }

    if (closeBtn && formPopup) {
        closeBtn.addEventListener('click', function () {
            formPopup.classList.remove('active');
            body.classList.remove('no-scroll');
            body.classList.remove('addblur');
        });
    }
});
